import {AGENT_CONSTS} from "../constants/agentConsts";

export const initialState = {
    agentsInfo: {},
    templatesList: [],
    language: 'english'
};

export default (state = initialState, action) => {
    switch (action.type) {
        case AGENT_CONSTS.GET_AGENTS_LIST:
            return {
                ...state,
                agentsInfo: action.payload,
            };
        case AGENT_CONSTS.GET_TEMPLATES_AGENT:
            return {
                ...state,
                templatesList: action.payload,
            };
        case AGENT_CONSTS.UPDATE_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            };
        default:
            return state;
    }
}